export default __webpack_public_path__ + "static/media/image1_200x200.09344a78.png";